<div class="container">
  <div class="row dashboard">
    <div class="col-md-3 col-lg-2 dashboard-left">
      <div class="client-dd" *ngIf="false">
        <app-alight-drop-down [group]="rootScope.dashboardForm" [controlName]="'clientId'" [required]="false"
          description="clientName" [disable]="false" label="Select a Client*" [value]="'clientId'"
          [list]="customerService.clients" >
        </app-alight-drop-down>
      </div>
      <div class="client-dd" >
       
    
        <app-alight-smart-search-drop-down [group]="rootScope.dashboardForm" [controlName]="'clientNameDash'" [required]="false"
        description="clientName" [clearSeleAvailable]="true" [disable]="false" label="Select a Client*" [value]="'clientName'"
        [list]="customerService.clients" (change)="rootScope.getDashboardLeftNavData($event)"
        (change)="rootScope.getDashboardMyTodo($event)"
        (change)="appointmentsCardService.getDashboardMyAppointments($event)" (change)="getExpand($event)"
       
        >
      </app-alight-smart-search-drop-down>
      

      </div>
      <span class="section-divider"></span>
      <div class="dashboard-left-nav pos-relative">

        <app-loader *ngIf="rootScope.dashboardLeftNavLoader" [loaderType]="loaderType"
          [loaderMsg]="rootScope.dashboardLeftNavLoaderMsg"></app-loader>

        <section *ngIf="rootScope.dashboardLeftNavError" class="error-wrapper">
          <f-alert variant="error" class="error-without-heading">
            <p class="full-width">
              {{ errorMsg}}
            </p>
          </f-alert>
          <button mat-button color="primary" title="Refresh" class="btn-refresh hide">
            Refresh
            <i class="fa-solid fa-arrows-rotate"></i>
          </button>
        </section>

       

        <div class="accordion-tab" *ngFor="
            let menu of rootScope.dashboardNavBarData;
            let menuLastItem = last
          ">
          <mat-accordion>
            <mat-expansion-panel [expanded]="selectedMenu == menu?.id">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <i [ngClass]="menu.icon"></i> {{ menu.heading }}
                </mat-panel-title>
              </mat-expansion-panel-header>

              <ul class="subLinks">              
              <li *ngFor="let subMenu of menu?.subMenuList | sortBy : 'heading'">

                <span (click)="activateLeftMenu(menu, subMenu)" [ngClass]="{
                    active: rootScope.selectedSubMenu == subMenu.id}" 
                    [ngClass]="(!subMenu.linkEnable)?'disabledLink':''">
                  
                  <button *ngIf="subMenu.subMenuList?.length == 0" [disabled]='!subMenu.linkEnable' class="navlinks">{{ subMenu?.heading }}</button>
                  <ng-container *ngIf="subMenu.subMenuList?.length > 0">
                    <mat-accordion class="nestedAccrodion">
                      <mat-expansion-panel disabled="{{!subMenu?.linkEnable}}">
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            <i [ngClass]="subMenu.icon"></i>
                            <span [ngClass]="subMenu.style" [ngClass]="{'linkDisabled':!subMenu?.linkEnable}"
                              [attr.tabIndex]="!subMenu?.linkEnable?-1:''">{{
                              subMenu.heading
                              }}</span>
                          </mat-panel-title>
                        </mat-expansion-panel-header>
                        <ul class="subLinks">
                          <li *ngFor="
                              let nestedMenu of subMenu.subMenuList
                                | sortBy: 'heading';
                              let i = index
                            " id="{{ nestedMenu.id }}" 
                             [ngClass]="{
                              'tab-active': tempMenuId
                                ? tempMenuId == nestedMenu.id
                                : selectedMenu == nestedMenu.id
                            }" [ngClass]="{'linkDisabled':!nestedMenu?.linkEnable}"
                            [attr.tabIndex]="!nestedMenu?.linkEnable?-1:''">
                            <button class="navlinks" (click)="activateLink(nestedMenu , subMenu ,$event)" [ngClass]="nestedMenu.style" [attr.tabIndex]="!nestedMenu?.linkEnable?-1:''"
                              [ngClass]="{'linkDisabled':!nestedMenu?.linkEnable}" title={{nestedMenu.heading}}
                              [disabled]='!nestedMenu?.linkEnable'>{{
                              nestedMenu.heading }}
                              <span [ngClass]="{
                                active: rootScope.selectedSubMenu == nestedMenu.id}" 
                                [ngClass]="(!nestedMenu.linkEnable)?'disabledLink':''"> </span>
                            </button>
                          </li>
                        </ul>
                      </mat-expansion-panel>
                    </mat-accordion>
                  </ng-container>
                </span>
                </li>
              </ul>
            </mat-expansion-panel>
          </mat-accordion>
          <span *ngIf="!menuLastItem" class="section-divider"></span>
        </div>

      </div>

      <div>
      </div>
    </div>
    <div class="col-md-9 col-lg-10 pos-relative dashboard-right">
      <app-dashboard-filter class="dashboard-filter" *ngIf="rootScope.openFilterDialog"></app-dashboard-filter>
      <div class="row dashboard-body">
        <div class="col-md-12 col-lg-8 dashboard-top">
          <div class="row main-data-card flex">
            <div class="col-md-6"> 
            <f-data-card class="data-card-1 ">
              <app-case-management-card></app-case-management-card>
            </f-data-card>
            </div>
            <div class="col-md-6"> 
            <f-data-card class="data-card-2 ">
              <app-appointments-card></app-appointments-card>
            </f-data-card>
            </div>
          
          <div class="col-md-12">

            <app-agent-interaction-history></app-agent-interaction-history>
          </div>
          </div>


        </div>

        <div class="col-md-12 col-lg-4 dashboard-bottom static-position">
          <div class="main-data-card">
            <f-data-card class="data-card-1 col-lg-12">
              <app-alis-registration></app-alis-registration>
            </f-data-card>
            <f-data-card class="data-card-2  col-lg-12 ">
              <!-- Connect to TBA GUI & eCS -->
              <app-tba-registration></app-tba-registration>
            </f-data-card>
          </div>
        </div>
      </div>
      <app-custom-dialog *ngIf="rootScope.customDialogData.displayCustomDialog" (actionOnClick)="buttonClick($event)">
      </app-custom-dialog>

    </div>
  </div>
</div>